import React from 'react';
import { useState } from "react";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export const LinkedDateCalendar = ({
	onChangeCallback,
	monthsShown,
	innerRef,
	initialMinDate,
	exceptions,
	hotelInputSet,
	windowObj
}) => {
	const today = new Date();
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [minDate, setMinDate] = useState( initialMinDate ? initialMinDate : today );
	const maxNumMonths = monthsShown;
	const [numMonths, setNumMonths] = useState(monthsShown);
	const onChange = (dates) => {
		const [start, end] = dates;
		setStartDate(start);
		setEndDate(end);
		onChangeCallback(start, end);
	};
	
	hotelInputSet.on('change', function(){
		let nextMinDate = today;
		
		for ( let j = 0; j < exceptions.length; j++ ) {
			if ( exceptions[j].input.value === exceptions[j].value ) {
				nextMinDate = exceptions[j].minDate > today ? exceptions[j].minDate : today;
			}
		}
		
		setMinDate(nextMinDate);
	});
	
	
	const applyMonthChanges = () => {
		if ( maxNumMonths === numMonths && maxNumMonths !== 1 && windowObj.innerWidth < 768 ) {
			setMonthsShown(1);
		} else if ( maxNumMonths !== 1 && numMonths !== maxNumMonths && windowObj.innerWidth >= 768 ) {
			setMonthsShown(maxNumMonths);
		}
	};
	
	windowObj.on('resize', function(){
		applyMonthChanges();
	});
	
	return (
		<DatePicker
			selected={startDate}
			onChange={onChange}
			startDate={startDate}
			endDate={endDate}
			minDate={minDate}
			monthsShown={ monthsShown }
			ref={innerRef}
			selectsRange
			inline
		/>
	)
};